export default __webpack_public_path__ + "static/media/Bluefury War Wolf.93bed999.jpg";